export const SetupTikTokIntegrationRoutes = [
  {
    path: 'setupTikTokIntegration',
    lazy: () => import('./SetupTikTokIntegration.page'),
  },
] as const
